export default __webpack_public_path__ + "static/phone-c971d9d3b600bf33a910fa1eebd733dd.png";